import { render, staticRenderFns } from "./ProfileTopCard.vue?vue&type=template&id=31b854a0&scoped=true&"
import script from "./ProfileTopCard.vue?vue&type=script&lang=js&"
export * from "./ProfileTopCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTopCard.vue?vue&type=style&index=0&id=31b854a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b854a0",
  null
  
)

export default component.exports